import { Platform, StyleSheet, Text, View, type ViewStyle } from 'react-native';
import DeviceInfo from 'react-native-device-info';
import ExpoConstants from 'expo-constants';
import Colors from 'src/core/utils/Colors';
import Constants from 'src/core/utils/Constants';
import Dimens from 'src/core/utils/Dimens';
import Translations from 'src/core/utils/Translations';

interface Props {
	extraStyle?: ViewStyle;
	textColor?: string;
}

function AppVersionText({ extraStyle, textColor = Colors.gray550 }: Props) {
	if (
		Platform.OS === Constants.platformWeb ||
		Platform.OS === Constants.platformMacos ||
		Platform.OS === Constants.platformWindows
	)
		return <View />;

	const appVersionText = Translations.appVersion(ExpoConstants.expoConfig?.version, DeviceInfo.getBuildNumber());

	return (
		<View style={[styles.centeredContainer, extraStyle]}>
			<Text style={[styles.text, { color: textColor }]}>{appVersionText}</Text>
		</View>
	);
}

const styles = StyleSheet.create({
	centeredContainer: {
		alignSelf: 'center',
		justifyContent: 'center',
	},
	text: {
		marginBottom: Dimens.padding16,
		textAlign: 'center',
		fontSize: Dimens.fontSize14,
		lineHeight: Dimens.lineHeight18,
		marginHorizontal: Dimens.padding18,
		marginVertical: Dimens.padding8,
		opacity: Dimens.opacity75,
	},
});

export default AppVersionText;
